import { StyleSheet } from 'react-native';
import Colors from '../../config/Colors';
import Layout from '../../config/Layout';

export default StyleSheet.create({
    content: {
        paddingHorizontal: Layout.gutter,
        paddingVertical: Layout.gutter,
        borderBottomWidth: 1,
        borderBottomColor: Colors.border
    }
});
